import { MatrixTerm, SeasonalMatrixStripType } from '../../../../Generated/Mark-It-View-Api';

export const SeasonalMatrixStripTypeLabels: Record<SeasonalMatrixStripType, string> = {
  [SeasonalMatrixStripType.Strip]: 'Strip',
  [SeasonalMatrixStripType.Month]: 'Month',
  [SeasonalMatrixStripType.Rolling]: 'Rolling',
};

export const SeasonalMatrixTerms: MatrixTerm[] = [
  MatrixTerm.Annual,
  MatrixTerm.Winter,
  MatrixTerm.Summer,
  MatrixTerm.FirstQuarter,
  MatrixTerm.SecondQuarter,
  MatrixTerm.ThirdQuarter,
  MatrixTerm.FourthQuarter,
];

export const RollingContractNumberLabels: Record<number, string> = {
  1: '1st Contract Month',
  2: '2nd Contract Month',
  3: '3rd Contract Month',
};
